<template>
  <div class="app">
    <header class="header">
      <div class="container">
        <h1>Robocytes</h1>
        <navigation class="navigation"></navigation>
      </div>
    </header>
    <transition mode="out-in" name="fade">
      <router-view class="container"></router-view>
    </transition>
  </div>
</template>

<style>
html {
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
}

h2 {
  margin-top: 30px;
}

body {
  margin: 0;
}

.header {
  margin-bottom: 40px;
  padding: 40px 0;
  background-color: rgb(0, 0, 0);
  color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.container {
  max-width: 800px;
  margin: 0 auto;
}

.navigation {
  margin-top: 30px;
}

img {
  max-width: 100%;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>

<script>
import Navigation from './components/Nav'

export default {
  name: 'App',
  components: {
    Navigation,
  },
}
</script>



// WEBPACK FOOTER //
// src/App.vue